import healthcheckimg from "../../Assets/healthchecks-img.png";
import healthieryou from "../../Assets/healthier-you.png";
import operate1 from "../../Assets/operate1.png"
import operate2 from "../../Assets/operate2.png"
import operate3 from "../../Assets/operate3.png"
import operate4 from "../../Assets/operate4.png"
import operate5 from "../../Assets/operate5.png"
import wellbeing1 from "../../Assets/wellbeing1.png";
import wellbeing2 from "../../Assets/wellbeing2.png";
import wellbeing3 from "../../Assets/wellbeing3.png";
import wellbeing4 from "../../Assets/wellbeing4.png";
import wellbeing5 from "../../Assets/wellbeing5.png";
import wellbeing6 from "../../Assets/wellbeing6.png";
import wellbeing7 from "../../Assets/wellbeing7.png";
import wellbeing8 from "../../Assets/wellbeing8.png";
import wellbeing9 from "../../Assets/wellbeing9.png";
import opt1 from "../../Assets/opt1.png"
import opt2 from "../../Assets/opt2.png"
import opt3 from "../../Assets/opt3.png"
import opt4 from "../../Assets/opt4.png"
import steppingoutimg from "../../Assets/stepping-out-img.png"
import sudher from "../../Assets/sudher.png"
import chandra from "../../Assets/chandra.png"
import tarun from "../../Assets/tarun.png"


export const serviceShowcaseData = [
  {
    imgSrc: healthcheckimg,
    title: `Wellness Starts At Home\nWith Our Home\n Health Checks`,
    buttonText: "Book Now",
    onButtonClick: () => console.log("Button Clicked"),
  },
];

export const healthCheck_data = {
  title: `First Step To Healthier You`,
  para1: `Don't let your health take a back seat – take control of your well-being today with our home health checks. Book now and embark on the journey to a healthier, happier you.`,
  para2: `Tailored to your individual needs, we make it easy for health assessments to fit into your busy schedules`,
  image: healthieryou,
};

export const operateheading = `How We Operate`;

export const operateservices = {
  a1: { title: "Book A Health Check", img: operate1 },
  a2: { title: "Home Sample Collection", img: operate2 },
  a3: { title: "Analysis", img: operate3 },
  a4: { title: "Download Reports", img: operate4 },
  a5: { title: "Consultation (Optional)", img: operate5 },
};


export const wellbeingheading = `Health Checks Tailored To Assess Your Well-Being`;
export const wellbeingservices = {
  o1: { title: "Cardiovascular", img: wellbeing1 },
  o2: { title: "Respiratory", img: wellbeing2 },
  o3: { title: "Liver", img: wellbeing3 },
  o4: { title: "Kidney", img: wellbeing4 },
  o5: { title: "Gastrointestinal", img: wellbeing5 },
  o6: { title: "Thyroid", img: wellbeing6 },
  o7: { title: "Pancreatic", img: wellbeing7 },
  o8: { title: "Reproductive", img: wellbeing8 },
  o9: { title: "Bone Health", img: wellbeing9 },
};

export const optheading = `When To Opt For Home Health Checks`;
export const optservices = {
  o1: { title: "Limited Mobility", img: opt1 },
  o2: { title: "Chronic Illness", img: opt2 },
  o3: { title: "Disability", img: opt3 },
  o4: { title: "Injury", img: opt4 },
}

export const stepping_out_data = {
  title: ` Take A Step Closer To Wellness Without Stepping Out`,
  para1: ` Don't let inconvenience be a barrier to your health. Take a step closer to wellness without stepping out – schedule your home health check with Wihan today and prioritize your well-being from the comfort of your own home.`,
  image: steppingoutimg,
};

export const rightFitData = {
  heading: `Why We’re The Right Fit`,
  list: [
    {
      text: "Qualified Phlebotomists",
      icon: (<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0098 8.28192L2.4071 13.8672L4.07046 9.56669L11.5124 8.17328L4.11557 6.14345L2.77028 1.88622L16.0077 8.28382L16.0098 8.28192ZM1.68147 15.2909L17.4465 8.81739C17.5149 8.79603 17.5782 8.76071 17.6322 8.71366C17.6863 8.66661 17.73 8.60886 17.7606 8.54408C17.8212 8.41922 17.8299 8.27554 17.7846 8.14458C17.7394 8.01361 17.644 7.90605 17.5194 7.84549L2.13919 0.416245C2.04738 0.372449 1.94473 0.356397 1.8438 0.370051C1.74288 0.383706 1.64805 0.426475 1.57093 0.493122C1.49382 0.559771 1.43776 0.647409 1.40961 0.74531C1.38146 0.843209 1.38245 0.947121 1.41246 1.04433L3.58551 7.93233L0.998363 14.6229C0.961716 14.7179 0.953672 14.8215 0.975223 14.9209C0.996775 15.0202 1.04698 15.111 1.11963 15.1821C1.19229 15.2531 1.28421 15.3013 1.38406 15.3206C1.4839 15.34 1.58729 15.3296 1.68147 15.2909Z" fill="#1D808C" />
      </svg>
      )
      ,
    },
    {
      text: "Latest Technologies",
      icon: (<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0098 8.28192L2.4071 13.8672L4.07046 9.56669L11.5124 8.17328L4.11557 6.14345L2.77028 1.88622L16.0077 8.28382L16.0098 8.28192ZM1.68147 15.2909L17.4465 8.81739C17.5149 8.79603 17.5782 8.76071 17.6322 8.71366C17.6863 8.66661 17.73 8.60886 17.7606 8.54408C17.8212 8.41922 17.8299 8.27554 17.7846 8.14458C17.7394 8.01361 17.644 7.90605 17.5194 7.84549L2.13919 0.416245C2.04738 0.372449 1.94473 0.356397 1.8438 0.370051C1.74288 0.383706 1.64805 0.426475 1.57093 0.493122C1.49382 0.559771 1.43776 0.647409 1.40961 0.74531C1.38146 0.843209 1.38245 0.947121 1.41246 1.04433L3.58551 7.93233L0.998363 14.6229C0.961716 14.7179 0.953672 14.8215 0.975223 14.9209C0.996775 15.0202 1.04698 15.111 1.11963 15.1821C1.19229 15.2531 1.28421 15.3013 1.38406 15.3206C1.4839 15.34 1.58729 15.3296 1.68147 15.2909Z" fill="#1D808C" />
      </svg>
      )
      ,
    },
    {
      text: "Expert Opinion",
      icon: (<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0098 8.28192L2.4071 13.8672L4.07046 9.56669L11.5124 8.17328L4.11557 6.14345L2.77028 1.88622L16.0077 8.28382L16.0098 8.28192ZM1.68147 15.2909L17.4465 8.81739C17.5149 8.79603 17.5782 8.76071 17.6322 8.71366C17.6863 8.66661 17.73 8.60886 17.7606 8.54408C17.8212 8.41922 17.8299 8.27554 17.7846 8.14458C17.7394 8.01361 17.644 7.90605 17.5194 7.84549L2.13919 0.416245C2.04738 0.372449 1.94473 0.356397 1.8438 0.370051C1.74288 0.383706 1.64805 0.426475 1.57093 0.493122C1.49382 0.559771 1.43776 0.647409 1.40961 0.74531C1.38146 0.843209 1.38245 0.947121 1.41246 1.04433L3.58551 7.93233L0.998363 14.6229C0.961716 14.7179 0.953672 14.8215 0.975223 14.9209C0.996775 15.0202 1.04698 15.111 1.11963 15.1821C1.19229 15.2531 1.28421 15.3013 1.38406 15.3206C1.4839 15.34 1.58729 15.3296 1.68147 15.2909Z" fill="#1D808C" />
      </svg>
      )
      ,
    },
    {
      text: "Tailored Recommendations",
      icon: (<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0098 8.28192L2.4071 13.8672L4.07046 9.56669L11.5124 8.17328L4.11557 6.14345L2.77028 1.88622L16.0077 8.28382L16.0098 8.28192ZM1.68147 15.2909L17.4465 8.81739C17.5149 8.79603 17.5782 8.76071 17.6322 8.71366C17.6863 8.66661 17.73 8.60886 17.7606 8.54408C17.8212 8.41922 17.8299 8.27554 17.7846 8.14458C17.7394 8.01361 17.644 7.90605 17.5194 7.84549L2.13919 0.416245C2.04738 0.372449 1.94473 0.356397 1.8438 0.370051C1.74288 0.383706 1.64805 0.426475 1.57093 0.493122C1.49382 0.559771 1.43776 0.647409 1.40961 0.74531C1.38146 0.843209 1.38245 0.947121 1.41246 1.04433L3.58551 7.93233L0.998363 14.6229C0.961716 14.7179 0.953672 14.8215 0.975223 14.9209C0.996775 15.0202 1.04698 15.111 1.11963 15.1821C1.19229 15.2531 1.28421 15.3013 1.38406 15.3206C1.4839 15.34 1.58729 15.3296 1.68147 15.2909Z" fill="#1D808C" />
      </svg>
      )
      ,
    },

  ]
}

export const testimonialData = [
  {
    title: `Explore Why We're The Preferred Option`,
    desc: `I recently used Wihan Home Health Services for a home health check,
and I'm impressed with their attention to detail. The healthcare
professional who visited my home made me feel at ease throughout
the process. It's reassuring to know that I can monitor my health from
the comfort of my own home.`,
    userimg: sudher,
    username: "Sudher varma"

  },
  {
    title: `Explore Why We're The Preferred Option`,
    desc: `I've been using home health checks from Wihan Home Health Service for
over a year now, and I couldn't be happier with the service. Their 
comprehensive assessments have helped me detect health issues early
on and make positive changes to my lifestyle. Plus, the convenience of 
having tests done at home is unbeatable. Thank you for making
healthcare so accessible!`,
    userimg: chandra,
    username: "Chandra Hasa"

  },
  {
    title: `Explore Why We're The Preferred Option`,
    desc: `I'm so relieved we discovered Wihan home health services for home 
health checks. As a new mom, finding time to take care of myself can
be tough, but their home visits make it so much easier. Knowing that
I can monitor my health and the health of my baby from home gives
me peace of mind. Thank you for your excellent service!`,
    userimg: tarun,
    username: "Tarun Ede "

  },
]
export const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: false,
  pauseOnFocus: false,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2, arrows: false } },
    { breakpoint: 768, settings: { slidesToShow: 2, arrows: false } },
    { breakpoint: 480, settings: { slidesToShow: 1, arrows: false } },
  ],
};